export default function sound(src) {
    this.sound = document.createElement("audio");
    this.sound.src = src;
    this.sound.setAttribute("preload", "auto");
    this.sound.setAttribute("controls", "none");
    this.sound.style.display = "none"
    this.sound.crossOrigin = 'anonymous';
    document.body.appendChild(this.sound);
    this.play = function (volume) {
        this.sound.volume = (Number.parseInt(volume) / 100)
        
        // Handle autoplay restrictions
        const playPromise = this.sound.play();
        if (playPromise !== undefined) {
            playPromise.catch(error => {
                // Autoplay was prevented, but this is expected behavior
                console.log('Audio autoplay prevented by browser:', error.message);
            });
        }
    }
    this.stop = function () {
        this.sound.pause();
    }
}